import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "./Team.css";

// Import images
import geetaImg from "../../assets/Team/img.png";
import gauravImg from "../../assets/Team/img2.png";
import neelamImg from "../../assets/Team/img3.png";
import vivekImg from "../../assets/Team/img4.png";

const teamMembers = [
  {
    name: "Ms. Geeta Singh",
    role: "Founder and Director",
    desc: "Leads renewable energy investments and advisory with a focus on bankable project development, clean energy innovation, and large-scale transaction execution.",
    img: geetaImg,
  },
  {
    name: "Mr. Gaurav Bhatiani",
    role: "Senior Advisor",
    desc: "Provides strategic guidance on energy transition and infrastructure development, and sustainable finance across South Asia.",
    img: gauravImg,
  },
  {
    name: "Ms.Neelam Singh",
    role: "International Business Development",
    desc: "Leads global partnerships and international business development supporting growth across renewable energy markets and cross-border collaborations.",
    img: neelamImg,
  },
  {
    name: "Mr. S. Vivekanand",
    role: "Head - Technologies and Projects",
    desc: "Oversees technology strategy, project management, and execution across renewable energy, power, and EV-related initiatives.",
    img: vivekImg,
  },
];

const Team = () => {
  const navigate = useNavigate(); // Initialize navigation

  const handleMeetTeamClick = () => {
    navigate("/fullteam"); // Added leading slash for absolute path
    window.scrollTo(0, 0);
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.2 } },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

  return (
    <section className="team-section">
      <div className="team-container">
        <div className="team-header-wrapper">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="team-top-badge"
          >
            Our Team
          </motion.div>

          <div className="header-content-row">
            <div className="header-left-box">
              <h2 className="team-main-title">Leadership & Core Team</h2>
              <p className="team-description">
                Our team brings deep expertise across renewable energy finance, engineering, and execution. <br className="d-none d-md-block" />
                We work closely with developers, investors, EPCs, and institutions across the full project lifecycle.
              </p>
            </div>
            <div className="header-right-box">
              <button
                className="meet-team-btn"
                onClick={handleMeetTeamClick}
              >
                Meet the Dazbog Team
              </button>
            </div>

          </div>
        </div>

        <motion.div
          className="team-cards-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          {teamMembers.map((member, index) => (
            <motion.div key={index} className="member-card-box" variants={cardVariants}>
              <div className="member-flex-wrapper">
                <div className="member-photo-container">
                  <img src={member.img} alt={member.name} />
                </div>
                <div className="member-details-container">
                  <h3 className="member-name-text">{member.name}</h3>
                  <p className="member-role-text">{member.role}</p>
                  <p className="member-bio-text">{member.desc}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Team;